export default __webpack_public_path__ + "static/media/stoly5.dc00bbac.jpg";